<form
    id="tenureModalForm"
    name="tenureModalForm"
    novalidate
    autocomplete="off"
    #tenureModalForm="ngForm">
    <div
        tabindex="-1"
        id="myModal"
        role="dialog"
        class="modal fade in">
        <div class="backdrop"></div>
        <div
            data-show="true"
            role="document"
            class="modal-dialog"
            [class]="modalSize">
            <div class="modal-content nlr-busy-modal">
                <div class="modal-header">
                    <button
                        type="button"
                        data-dismiss="modal"
                        aria-label="Close"
                        (click)="closeDialog()"
                        class="close">
                        <i class="nlrp-icon nlrp-icon-close"></i
                    ></button>
                    <h3 class="modal-title">{{formerTenureUIConfigLookup.addParentTenureModalLabel}}</h3>
                </div>
                <div class="modal-body">
                    <div class="well">
                        @for (tenure of model.tenures; track trackByIndex(tenureIndex, tenure); let tenureIndex = $index) {
                            <div class="row">
                                <div class="col-xs-11">
                                    <nlr-former-tenure-detail
                                        [name]="'tenure'+tenureIndex"
                                        [id]="'tenure'+tenureIndex"
                                        [tenure]="tenure"
                                        [formerTenureValidityLookup]="formerTenureValidityLookup"
                                        [formerTenureUIConfigLookup]="formerTenureUIConfigLookup"
                                        [parentPlanTypeLookups]="parentPlanTypeLookups"
                                        [subjectLandTypeLookups]="subjectLandTypeLookups"
                                        [tenureDisplayType]="tenureDisplayType"
                                        [readonly]="readonly">
                                    </nlr-former-tenure-detail>
                                </div>
                                <div class="col-xs-1 text-center">
                                    <label class="control-label">&nbsp;</label>
                                    @if (!formerTenureValidityLookup.prePopParentPlan) {
                                        <div>
                                            <i
                                                class="nlrp-icon nlrp-icon-add-circle"
                                                (click)="addTenure(tenureIndex)"
                                                title="Add tenure"
                                                tabindex="0"
                                                data-test-automation="tenure-detail-add-tenure"></i>
                                            <i
                                                class="nlrp-icon nlrp-icon-remove-circle"
                                                (click)="removeTenure(tenureIndex)"
                                                title="Remove tenure"
                                                tabindex="0"
                                                data-test-automation="tenure-detail-remove-tenure"></i>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                    <div class="modal-footer">
                        <span class="inline-buttons">
                            <button
                                type="button"
                                class="btn btn-default nlr-btn-sm"
                                id="verifyBtn"
                                title="Verify"
                                (click)="verify()"
                                [disabled]="isVerifyDisabled()"
                                data-test-automation="tenure-detail-verify"
                                >Verify</button
                            >
                        </span>
                        <span class="inline-buttons">
                            <button
                                type="button"
                                class="btn btn-default nlr-btn-sm"
                                title="Save"
                                id="saveBtn"
                                (click)="save()"
                                [disabled]="isSaveDisabled() ||
                                 (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                                data-test-automation="tenure-detail-save"
                                >OK</button
                            >
                        </span>
                        <span class="inline-buttons">
                            <button
                                type="button"
                                class="btn btn-warning nlr-btn-sm"
                                title="Cancel"
                                (click)="closeDialog()"
                                data-test-automation="tenure-detail-cancel"
                                >Cancel</button
                            >
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
